import React, { memo } from 'react';
import { MissingText } from './style';

const MissingMessage = ({ text, bottom }) => {
  return <MissingText bottom={bottom}>{text || 'This field is missing'}</MissingText>;
};

export default memo(MissingMessage);
